import { RegistrationUpsert } from '../registration/model';

type Address = Pick<
  BaseCreateUser,
  | 'addressLine1'
  | 'addressLine2'
  | 'addressCity'
  | 'addressZipcode'
  | 'addressCountry'
  | 'addressState'
  | 'phone'
>;

export function sameAddress(user: Address, otherUser: Address): boolean {
  return (
    user.addressLine1 === otherUser.addressLine1 &&
    user.addressLine2 === otherUser.addressLine2 &&
    user.addressCity === otherUser.addressCity &&
    user.addressZipcode === otherUser.addressZipcode &&
    user.addressCountry === otherUser.addressCountry &&
    user.addressState === otherUser.addressState &&
    user.phone === otherUser.phone
  );
}

export interface BaseCreateUser {
  firstName?: string;
  lastName?: string;
  preferredName?: string | null;
  bornAt?: string | null;
  phone?: string | null;
  addressCity?: string;
  addressCountry?: string;
  addressLine1?: string;
  addressLine2?: string | null;
  addressState?: string;
  addressZipcode?: string;
  newsletter: boolean;
  email?: string | null;
}

export interface CreateUser extends BaseCreateUser {
  conventionId?: number;
  externalOauth?: unknown;
  identityId?: string;
  password: string;
  registration?: RegistrationUpsert;
  username: string;
}

interface CreateSubUserChild {
  registration: RegistrationUpsert;
  child: true;
}

export interface CreateSubUserAdult extends BaseCreateUser {
  registration: RegistrationUpsert;
  child: false;
}

export type CreateSubUser = CreateSubUserChild | CreateSubUserAdult;

export interface CreateSubUserResponse {
  userId: number;
}

export interface CreateUserResponse {
  verified: boolean;
}
